// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"floatingcontainer_wrapper__Z5tod","subWrapper":"floatingcontainer_subWrapper__heVwY"};